import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "header-big-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Core12")
const _hoisted_3 = {
  key: 0,
  class: "header-user-circle-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_transparent_button = _resolveComponent("c-transparent-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createBlock(_component_app_header, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    end: _withCtx(() => [
      (_ctx.user)
        ? (_openBlock(), _createBlock(_component_c_transparent_button, {
            key: 0,
            class: "header-user-btn",
            onClick: _ctx.openUserInfo
          }, {
            default: _withCtx(() => [
              (_ctx.isTabletDown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.userIconLabel), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.fullName), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "buttons-before"),
      _createVNode(_component_c_transparent_button, {
        onClick: _ctx.openSettings,
        "data-action": "settings-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            name: "settings-outline",
            class: "icon-medium"
          }),
          _createElementVNode("span", {
            class: "icon-badge-network-status",
            style: _normalizeStyle({ backgroundColor: _ctx.networkStatusColor })
          }, null, 4)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}